import React, { useState } from 'react';
import classNames from 'classnames';

import {
	Dropdown, DropdownDisclosure, DropdownWrapper, useDropdownState
} from 'components/Dropdown';
import getSortByUrl from 'features/sort/getSortByUrl';
import getSortByEventName from 'features/sort/getSortByEventName';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import { triggerEvent } from 'utilities/dom';

import './SortByDropdown.scss';

const SortByDropdown = () => {

	const options = Object.entries(lp.pageData?.sortOptions?.Mappings).map(([ k, v ]) => ({ key: k, value: v.DisplayFieldName }));
	const initialSelected = options.find((opt) => lp.pageData?.sortOptions?.SelectedSortByValue?.toString() === opt.key);
	const [ selected, setSelected ] = useState(initialSelected);
	const dropdown = useDropdownState(false);

	const onButtonClick = () => {

		if (!dropdown.show) {

			setGenericEvent({ event_name: 'sortby_expand' });

		}
		dropdown.toggleDropdown();

	};

	const onOptionClick = (event, option) => {

		if (window.dynamicSort === true) {

			event.preventDefault();
			const destinationUrl = event.currentTarget.getAttribute('href');
			triggerEvent.call(document, 'dynamicNavigation', { destinationUrl });
			setSelected(option);

		}
		setGenericEvent({ event_name: getSortByEventName(option.value) });

	};

	const classNameSortByDropdown = classNames(
		'SortByDropdown',
		(initialSelected.key !== selected.key) && 'SortByDropdown--loading'
	);

	return (
		<DropdownWrapper className={classNameSortByDropdown}>
			<DropdownDisclosure onButtonClick={onButtonClick} {...dropdown} className="SortByDropdown__button">
				<svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11.362 14.786" aria-hidden="true">
					<g id="Component_8_2" data-name="Component 8 – 2" transform="translate(0.37 0.742)">
						<path id="Path_1" data-name="Path 1" d="M201.977,147.116v13.172" transform="translate(-200.13 -146.985)" fill="none" stroke="#333" strokeWidth="1" />
						<path id="Path_4" data-name="Path 4" d="M201.977,147.116v13.172" transform="translate(210.753 160.287) rotate(180)" fill="none" stroke="#333" strokeWidth="1" />
						<path id="Path_2" data-name="Path 2" d="M201.13,147.684l1.805-1.986,1.817,1.986" transform="translate(-201.13 -145.698)" fill="none" stroke="#333" strokeWidth="1" />
						<path id="Path_3" data-name="Path 3" d="M201.13,147.684l1.805-1.986,1.817,1.986" transform="translate(211.753 159) rotate(180)" fill="none" stroke="#333" strokeWidth="1" />
					</g>
				</svg>
Sort By:
				{' '}
				{initialSelected.value}
			</DropdownDisclosure>
			{dropdown.show && (
				<Dropdown
					{...dropdown}
					alignEdge="right"
					anchorEdge="bottom"
					hideOnEscape
					hideOnOutsideClick
				>
					<div className="SortByDropdown__wrapper">
						{options.map((opt) => (
							selected.key === opt.key
								? (
									<span aria-selected="true" className="SortByDropdown__option SortByDropdown__option--selected" key={opt.key}>
										{opt.value}
										{initialSelected.key !== opt.key && <span className="lpIcon-loading" />}
									</span>
								)
								: (
									<a href={getSortByUrl(opt.key)} onClick={(e) => onOptionClick(e, opt)} aria-selected="false" className="SortByDropdown__option" key={opt.key}>
										{opt.value}
									</a>
								)
						))}
					</div>
				</Dropdown>
			)}
		</DropdownWrapper>
	);

};

export default SortByDropdown;
